// extracted by mini-css-extract-plugin
export default {"outbox":"RepoOutboxBadge_outbox__sRrqa","count":"RepoOutboxBadge_count__UFEI1"};